import React, { useMemo } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { Sensors, SensorsOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../shared/atoms/CustomTooltip';
import { useSensorReadingsContext } from '../../../context/SensorReadingsContext';
import { connectionColorObj } from '../../../themes';

const SensorConnection = () => {
  const { connection, subscribe, unsubscribe } = useSensorReadingsContext();
  const { t, i18n } = useTranslation();

  const isConnecting = useMemo(
    () => connection.status === 'Connecting',
    [connection.status],
  );

  const isError = useMemo(
    () =>
      connection.status === 'Error' ||
      connection.status === 'ConnectionDisrupted',
    [connection.status],
  );

  const displayConnection = useMemo(
    () => (
      <Stack>
        <Typography>{t('tools_menu.connection.title')}</Typography>
        <Typography sx={{ paddingTop: '10px' }}>
          {t('tools_menu.connection.status', {
            status: connection.status,
          })}
        </Typography>
        <Typography>
          {connection.updated.toLocaleString(i18n.language)}
        </Typography>
        {!isConnecting && !isError && (
          <Typography sx={{ paddingTop: '10px' }}>
            {t('tools_menu.connection.click', { status: connection.status })}
          </Typography>
        )}
        {isError && (
          <Typography sx={{ paddingTop: '10px' }}>
            {t('tools_menu.connection.contact')}
          </Typography>
        )}
      </Stack>
    ),
    [
      connection.status,
      connection.updated,
      i18n.language,
      isConnecting,
      isError,
      t,
    ],
  );

  return (
    <CustomTooltip title={displayConnection}>
      <Box>
        <IconButton
          size="large"
          aria-label="connection status"
          sx={{
            color: `${
              connectionColorObj[connection.status] ||
              connectionColorObj.Disconnected
            } !important`,
          }}
          onClick={connection.status === 'Connected' ? unsubscribe : subscribe}
          disabled={isConnecting || isError}
        >
          {connection.status === 'Connected' ? (
            <Sensors sx={{ fontSize: { xs: 26, sm: 30 } }} />
          ) : (
            <SensorsOff sx={{ fontSize: { xs: 26, sm: 30 } }} />
          )}
        </IconButton>
      </Box>
    </CustomTooltip>
  );
};

export default SensorConnection;
